import { createFileRoute } from '@tanstack/react-router'
import { OpportunityBoard } from '~/features/admin/opportunity-board'

export const Route = createFileRoute('/admin/opportunities')({
  component: OpportunityBoard,
})
